<template>
  <v-container class="fill-height">
    <v-snackbar v-model="snackbar" :top="true" :right="true" :vertical="true" color="success" :timeout="5000">
      Successfully deleted
      <v-btn dark text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-row justify="center">
      <v-dialog v-model="confirmDialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>Do you really want to delete these records? This process cannot be undone.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="cancel">Cancel</v-btn>
            <v-btn color="green darken-1" text @click="agree">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <v-card class="v-table-card" :elevation="3">
      <v-data-table
        :headers="headers"
        :items="buildings"
        :items-per-page="itemsPerPage"
        :page.sync="currentPage"
        :loading="tableLoading"
        :sort-by.sync="sortBy"
        :sort-desc.sync="descending"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <div class="flex-grow-1"></div>
            <v-btn color="indigo" dark class="mb-1" to="/buildings/create">
              Добави нова сграда
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:item.image="props">
          <img style="width: 100px; display: block; height: auto;" :src="props.item.image" alt="">
        </template>
        <template v-slot:item.title="props">
          {{ props.item.translations.title }}  
        </template> 
        <template v-slot:item.status="props">
          {{ props.item.status === 1 ? 'Настоящ проект' : '' }}
          {{ props.item.status === 2 ? 'Завършен проект' : '' }}
          {{ props.item.status === 3 ?  'Бъдещ проект' : '' }}
        </template>
        <template v-slot:item.actions="props">
          <v-icon @click.native="handleEditClick(props.item.id)" small class="mr-2">mdi-pencil</v-icon>
          <v-icon @click.native="handleDeleteClick(props.item.id)" small>mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        search: '',
        confirmDialog: false,
        deleteId: null,
        snackbar: false,
        itemsPerPage: 5,
        currentPage: 1,
        tableLoading: true,
        sortBy: 'createdAt',
        descending: true,
        headers: [
          { text: '', align: 'left', sortable: false, value: 'image', width: '100px' },
          { text: 'Заглавие', sortable: false, value: 'title', width: '20%' },
          { text: 'Тип', value: 'status' },
          { text: 'Дата на създаване', value: 'createdAt' },
          { text: 'Последно редактиране', value: 'updatedAt' },
          { text: 'Actions', value: 'actions', sortable: false, align: 'right' }
        ]
      }
    },
    created () {
      this.$store.dispatch('fetchBuildings')
        .then(() => this.tableLoading = false)
    },
    computed: {
      buildings () {
        return this.$store.state.building.buildings
      }
    },
    methods: {
      handleEditClick (id) {
        this.$router.push({ name: 'buildings-edit', params: { id } })
      },
      handleDeleteClick (id) {
        this.confirmDialog = true
        this.deleteId = id
      },
      cancel () {
        this.confirmDialog = false
        this.deleteId = null
      },
      agree () {
        this.confirmDialog = false
        this.$store.dispatch('removeBuilding', this.deleteId)
          .then(res => {
            if (res.data.success) {
              this.snackbar = true
              this.$store.dispatch('fetchBuildings')

              this.deleteId = null
            }
          })
      }
    }
  }
</script>
